module.exports = __webpack_public_path__ + "img/logo2.e4a71e0d.png";